import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";
import { WorkerVehicle } from "./worker-vehicle";
import { Business } from "../../business/_types/business";
import { Worker } from "./worker";
import { Tax } from "../../taxes/_types/tax";
import { WorkerBillableItemType } from "./worker-billable-item-type";
import { Zone } from "../../zones/_types/zone";

export class WorkerBillableItem extends Resource {
    public override type = 'workerBillableItems';

    @prop()
    @required()
    public workerId!: string;
    public worker!: Worker;

    @prop()
    @required()
    public workerBillableItemTypeId!: string;
    public workerBillableItemType!: WorkerBillableItemType;

    @prop()    
    public workerVehicleId?: string;
    public workerVehicle?: WorkerVehicle;

    @prop()    
    public businessId?: string;
    public business?: Business;

    @prop()    
    public zoneId?: string;
    public zone?: Zone;

    @prop()
    @required()
    public description!: string;

    @prop()
    @required()
    public quantity!: number;    

    @prop()
    @required()
    public price!: number;

    @prop()
    @required()
    public taxId!: string;
    public tax!: Tax;

    @prop()
    public isPeriodic: boolean = false;

    @prop()    
    public startDate!: Date;

    @prop()
    public endDate!: Date;

    @prop()
    public nextDate!: Date;

    @prop()
    public notes?: string;

    @prop()    
    public decimalValue1?: number;

    @prop()
    @required()
    public isPayToWorker: boolean = false;

    @prop()
    @required()
    public active: boolean = false;

}